// ============================================================================
// File: src/modules/ppe/pages/procurement/dashboard/ProcurementDashboard.jsx
// Module: PPE → Procurement → Dashboard
// Purpose:
//   Main Procurement Dashboard landing page.
//   - Calls dashboard API
//   - Orchestrates layout
//   - Renders KPI + Charts + Tables
// ============================================================================

import React, { useEffect, useState } from "react";
import "./styles/dashboard.css";

import DashboardHeader from "./components/layout/DashboardHeader";
import DashboardFilters from "./components/layout/DashboardFilters";

import KPIContainer from "./components/kpi/KPIContainer";
import ProcurementFunnelChart from "./components/charts/ProcurementFunnelChart";
import SpendTrendChart from "./components/charts/SpendTrendChart";
import FulfillmentDonut from "./components/charts/FulfillmentDonut";
import PendingActionsTable from "./components/tables/PendingActionsTable";
import AlertsPanel from "./components/alerts/AlertsPanel";
import AnalyticsCard from "./components/layout/AnalyticsCard";

import { fetchProcurementDashboard } from "./services/dashboardService";

export default function ProcurementDashboard() {

  // ---------------------------------------------------------------------------
  // STATE
  // ---------------------------------------------------------------------------
  const [loading, setLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState(null);

  // ---------------------------------------------------------------------------
  // LOAD DASHBOARD DATA
  // ---------------------------------------------------------------------------
  useEffect(() => {
    loadDashboard();
  }, []);

  const loadDashboard = async () => {
    try {
      setLoading(true);

      const response = await fetchProcurementDashboard();

      console.log("✅ Procurement Dashboard Response:", response);

      // response structure:
      // { success:true, data:{...} }
      setDashboardData(response.data);

    } catch (error) {
      console.error("❌ Dashboard Load Error:", error);
    } finally {
      setLoading(false);
    }
  };

  // ---------------------------------------------------------------------------
  // RENDER
  // ---------------------------------------------------------------------------
  return (
    <div className="procurement-dashboard">

      {/* Header */}
      <DashboardHeader />

      {/* Alerts */}
      {/* Alerts */}
        {dashboardData?.alerts?.length > 0 && (
        <AlertsPanel alerts={dashboardData.alerts} />
        )}


      {/* Filters */}
      <DashboardFilters />

      {/* KPI Section */}
      <KPIContainer
        loading={loading}
        kpis={dashboardData?.kpis}
      />

      {/* ================= ANALYTICS GRID ================= */}
      <div className="dashboard-grid">

        {/* Funnel (Primary Insight) */}
        <AnalyticsCard
          title="Procurement Funnel"
          subtitle="Document flow across procurement lifecycle"
        >
          <ProcurementFunnelChart
            data={dashboardData?.funnel}
          />
        </AnalyticsCard>

        {/* Fulfillment Status */}
        <AnalyticsCard
          title="PO Fulfillment Status"
          subtitle="Ordered vs received quantity"
        >
          <FulfillmentDonut
            data={dashboardData?.po_grn_fulfillment}
          />
        </AnalyticsCard>

      </div>

      {/* Spend Trend */}
      <AnalyticsCard
        title="Monthly Procurement Spend"
        subtitle="Purchase order value trend"
      >
        <SpendTrendChart
          data={dashboardData?.spend_trend}
        />
      </AnalyticsCard>

      {/* Pending Actions */}
      <AnalyticsCard
        title="Pending Actions"
        subtitle="Documents awaiting attention"
      >
        <PendingActionsTable
          data={dashboardData?.pending_actions}
        />
      </AnalyticsCard>

    </div>
  );
}
